import { computed } from 'vue';
import { controllerModel } from 'shared';

import type { FareFamilyChoiceSpec } from '../model';

interface FareFamilyGroupBottomSheetParams extends Record<string, unknown> {
  choices: FareFamilyChoiceSpec[];
  groupKey: string | undefined;
  segments: {
    arr: string;
    dep: string;
  };
  selectedId: number | null | undefined;
  isDomestic?: boolean;
}

export function useFareFamilyBottomSheet() {
  const bottomSheet = controllerModel.useBottomSheet();
  const bottomSheetName = 'fare-family-group';

  return {
    name: bottomSheetName,
    show: (params: FareFamilyGroupBottomSheetParams) =>
      bottomSheet.show(bottomSheetName, params),
    hide: () => bottomSheet.hide(bottomSheetName),
    params: computed(
      () =>
        bottomSheet.getParams(
          bottomSheetName,
        ) as FareFamilyGroupBottomSheetParams,
    ),
  };
}
